/* Charger product page (sections/zvp-product.liquid): gallery thumbnails and
   the option pills (cable length). Picking an option sets the variant on the
   add-to-cart form and refreshes price, EMI, picture and the page address. */
(function () {
  function money(paise) { return 'Rs. ' + Math.round(paise / 100).toLocaleString('en-IN'); }

  function init(root) {
    if (root.__zvp) return;
    root.__zvp = 1;
    var main = root.querySelector('.zvp__main');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.zvp__thumb'));
    function show(thumb) {
      if (!thumb || !main) return;
      thumbs.forEach(function (t) { t.classList.toggle('is-on', t === thumb); });
      main.removeAttribute('srcset');
      main.src = thumb.getAttribute('data-src');
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t); }); });

    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-variants]').textContent); } catch (e) {}
    var groups = Array.prototype.slice.call(root.querySelectorAll('.zvp__pills'));
    if (!groups.length || !variants.length) return;
    var idInput = root.querySelector('.product-variant-id');
    var addBtn = root.querySelector('.zvp__add');
    var addText = addBtn && addBtn.querySelector('span');
    var addLabel = addText ? addText.textContent : '';
    var priceEl = root.querySelector('[data-price]'), emiEl = root.querySelector('[data-emi]');
    var months = parseInt(root.getAttribute('data-emi-months'), 10) || 0;

    function chosen() {
      return groups.map(function (g) {
        var on = g.querySelector('.zvp__pill.is-on');
        return on ? on.getAttribute('data-value') : null;
      });
    }
    function apply() {
      var pick = chosen();
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === pick[i]; }); })[0];
      if (!v) return;
      idInput.value = v.id;
      idInput.disabled = !v.available;
      if (addBtn) addBtn.disabled = !v.available;
      if (addText) addText.textContent = v.available ? addLabel : 'Sold out';
      if (priceEl) priceEl.textContent = money(v.price);
      if (emiEl && months) emiEl.textContent = money(v.price / months) + '/mo';
      if (v.media) show(thumbs.filter(function (t) { return t.getAttribute('data-media') === String(v.media); })[0]);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }
    groups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var pill = e.target.closest ? e.target.closest('.zvp__pill') : null;
        if (!pill || pill.classList.contains('is-on')) return;
        Array.prototype.forEach.call(g.querySelectorAll('.zvp__pill'), function (p) { p.classList.toggle('is-on', p === pill); });
        apply();
      });
    });
  }

  function mount(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-zvp]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mount(); });
  else mount();
  document.addEventListener('shopify:section:load', function (e) { mount(e.target); });
})();

/* ---- "Complete the install": add-ons as a tick list -----------------------
   Same feed as the "Complete your setup" popup (snippets/zev-upsell). The
   popup still does the adding to cart; whatever is ticked here is ticked in
   it when it opens, through the popup's own zevUpsellToggle / zevUpsellWPick. */
(function () {
  var API = 'https://widget.zevpoint.com/api/public/installations/product-addons';
  function inr(v) { return 'Rs. ' + Math.round(v).toLocaleString('en-IN'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function init(root) {
    if (root.__zvpA) return;
    root.__zvpA = 1;
    var list = root.querySelector('.zvp-addons__list'), foot = root.querySelector('.zvp-addons__foot');
    var totalEl = root.querySelector('[data-total]'), items = [], ticked = {};

    fetch(API + '?shopify_product_id=' + root.getAttribute('data-product'))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.success || !d.is_charger) return;
        if (d.installation) {
          items.push({ key: String(d.installation.variant_id), name: 'Installation by certified technician', why: 'Wiring, mounting and safety testing at your home', price: d.installation.price_incl_gst, reco: true });
        }
        (d.addons || []).forEach(function (a) {
          if (a.role === 'box') return;            /* the popup adds the right enclosure box itself */
          items.push({ key: String(a.variant_id), name: a.name, why: a.why || (a.is_per_metre ? 'Starts at 10 m; change the length in the next step' : ''), price: a.price_incl_gst, reco: a.is_recommended, perMetre: a.is_per_metre });
        });
        (d.warranty_plans || []).slice(0, 1).forEach(function (p) {
          items.push({ key: 'w:' + p.plan_id, plan: p.plan_id, name: 'Extended warranty', why: p.duration_label + ' beyond the standard warranty', price: p.price_incl_gst });
        });
        if (!items.length) return;
        list.innerHTML = items.map(function (it, i) {
          return '<label class="zvp-addon"><input type="checkbox" data-i="' + i + '"><span class="zvp-addon__box" aria-hidden="true"></span>'
            + '<span class="zvp-addon__body"><b>' + esc(it.name) + (it.reco ? ' <em>Recommended</em>' : '') + '</b>' + (it.why ? '<small>' + esc(it.why) + '</small>' : '') + '</span>'
            + '<span class="zvp-addon__price">' + inr(it.price) + (it.perMetre ? '<small>per metre</small>' : '') + '</span></label>';
        }).join('');
        root.hidden = false;
      })
      .catch(function () {});

    list.addEventListener('change', function (e) {
      var it = items[+e.target.getAttribute('data-i')];
      if (!it) return;
      if (e.target.checked) ticked[it.key] = it; else delete ticked[it.key];
      var total = 0, n = 0;
      Object.keys(ticked).forEach(function (k) { total += ticked[k].price * (ticked[k].perMetre ? 10 : 1); n++; });
      foot.hidden = !n;
      totalEl.textContent = inr(total);
    });
    root.querySelector('.zvp-addons__go').addEventListener('click', function () {
      var add = document.querySelector('.zvp__add[type="submit"]');
      if (add) add.click();
    });

    /* when the popup opens, make its ticks match ours (once per opening) */
    new MutationObserver(function () {
      var box = document.getElementById('zevUpsellBox');
      if (!box || box.__zvpSynced) return;
      box.__zvpSynced = 1;
      items.forEach(function (it) {
        var want = !!ticked[it.key];
        if (it.plan) {
          var on = !/view plans|hide/.test((box.textContent.split('Extended warranty')[1] || 'view plans').slice(0, 40));
          if (want !== on && window.zevUpsellWPick) window.zevUpsellWPick(it.plan);
          return;
        }
        var card = document.getElementById('zevUp-' + it.key);
        if (!card) return;
        var isOn = /eaf6ef|234, 246, 239/.test(card.getAttribute('style') || '');
        if (want !== isOn && window.zevUpsellToggle) window.zevUpsellToggle(it.key);
      });
    }).observe(document.body, { childList: true });
  }
  function mount() { Array.prototype.forEach.call(document.querySelectorAll('[data-zvp-addons]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
  document.addEventListener('shopify:section:load', mount);
})();

/* ---- "Will it work with my car?" -------------------------------------------
   Speed rules (same as the home finder and the product sheet):
   - a single-phase car on a three-phase charger takes one phase:
     11 kW unit -> 3.6 kW, 22 kW unit -> 7.5 kW
   - otherwise the lower of what the car accepts and what the charger gives. */
(function () {
  var FEED = 'https://widget.zevpoint.com/api/public/plan/cars';
  var ONE_PHASE = { 11: 3.6, 22: 7.5 };
  var APPROX = String.fromCharCode(8776) + ' ', DASH = String.fromCharCode(8212), APOS = String.fromCharCode(8217), ARROW = String.fromCharCode(8594);
  function speed(ch, car) {
    var out = parseFloat(ch.kw);
    if (ch.phase === 'three' && car.o < 11) out = ONE_PHASE[out] || Math.round(out / 3 * 10) / 10;
    return Math.round(Math.min(car.o, out) * 10) / 10;
  }
  function slugify(n) { return n.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }

  function init(root) {
    if (root.__zvpF) return;
    root.__zvpF = 1;
    var me;
    try { me = JSON.parse(root.querySelector('[data-fit]').textContent); } catch (e) { return; }
    var sel = root.querySelector('.zvp-fit__select'), out = root.querySelector('.zvp-fit__out'), stat = root.querySelector('[data-static]');
    var cars = [];
    function q(a) { return root.querySelector(a); }

    function show(car) {
      if (!car) { out.hidden = true; if (stat) stat.hidden = false; return; }
      var kw = speed(me, car);
      q('[data-speed]').textContent = kw + ' kW';
      q('[data-range]').textContent = car.b && car.r ? APPROX + Math.round(kw * car.r / car.b) + ' km' : DASH;
      q('[data-hours]').textContent = car.b ? APPROX + (Math.round(car.b / kw * 10) / 10) + ' h' : DASH;
      var byCar = kw >= car.o - 0.05;
      q('[data-limit]').textContent = byCar ? 'Your car' + APOS + 's onboard charger' : (me.phase === 'three' && car.o < 11 ? 'One phase of this charger' : 'This charger');
      var advice = q('[data-advice]');
      advice.textContent = '';
      var faster = me.sisters.filter(function (s) { return speed(s, car) > kw + 0.05; }).sort(function (a, b) { return speed(b, car) - speed(a, car) || a.price - b.price; })[0];
      var cheaper = me.sisters.filter(function (s) { return speed(s, car) >= kw - 0.05 && s.price < me.price; }).sort(function (a, b) { return a.price - b.price; })[0];
      var lead = car.n + ' accepts up to ' + car.o + ' kW AC. ';
      var pick = null, text;
      if (faster) { pick = faster; text = lead + me.name + ' gives it ' + kw + ' kW; ' + faster.name + ' gives it ' + speed(faster, car) + ' kW. '; }
      else if (cheaper) { pick = cheaper; text = lead + 'A bigger charger won' + APOS + 't make it faster ' + DASH + ' ' + cheaper.name + ' charges it at the same ' + kw + ' kW for less. '; }
      else text = lead + me.name + ' is the right fit.' + (me.phase === 'three' ? ' It needs a three-phase connection.' : '');
      advice.appendChild(document.createTextNode(text));
      if (pick) {
        var a = document.createElement('a');
        a.href = pick.url + '?ev=' + slugify(car.n);
        a.textContent = 'See ' + pick.name + ' ' + ARROW;
        advice.appendChild(a);
      }
      out.hidden = false;
      if (stat) stat.hidden = true;
    }

    sel.addEventListener('change', function () { show(cars.filter(function (c) { return c.n === sel.value; })[0]); });

    fetch(FEED).then(function (r) { return r.json(); }).then(function (d) {
      var feed = Array.isArray(d) ? d : (d.cars || []);
      cars = feed.map(function (c) {
        return { n: (c.brand + ' ' + c.model).trim(), brand: c.brand, o: +c.onboard_charger_kw || 7.5, b: +c.battery_kwh || 0, r: +c.range_km || 0 };
      }).sort(function (a, b) { return a.n.localeCompare(b.n); });
      var group = null, last = null;
      cars.forEach(function (c) {
        if (c.brand !== last) { group = document.createElement('optgroup'); group.label = c.brand; sel.appendChild(group); last = c.brand; }
        var o = document.createElement('option');
        o.value = c.n; o.textContent = c.n;
        group.appendChild(o);
      });
      /* a link from a sister product (or a sales link) carries the car */
      var slug = null;
      try { slug = new URLSearchParams(window.location.search).get('ev'); } catch (e) {}
      var pre = slug && cars.filter(function (c) { return slugify(c.n) === slug; })[0];
      if (pre) { sel.value = pre.n; show(pre); }
    }).catch(function () { sel.hidden = true; });
  }
  function mount() { Array.prototype.forEach.call(document.querySelectorAll('[data-zvp-fit]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
  document.addEventListener('shopify:section:load', mount);
})();
